import React from 'react';

import FontAwesome from 'components/FontAwesome';
import OptionTile from '../assets/OptionTile';
import useDeleteWatermark from '../useDeleteWatermark';

export interface DeleteWatermarkTileProps {
  className?: string;
}

const DeleteWatermarkTile: React.FC<DeleteWatermarkTileProps> = props => {
  const { className } = props;
  const handleClick = useDeleteWatermark();

  return (
    <OptionTile
      className={className}
      icon={
        <FontAwesome
          icon="trash-alt"
          style={{ color: '#c82828', height: 36, width: 'auto' }}
        />
      }
      label="delete"
      onClick={handleClick}
    />
  );
};

export default DeleteWatermarkTile;
